import moment from 'moment';

export default function validateExpiryDate(value: string) {
  if (!/0[1-9]|1[0-2]\s\/\s\d{2}/.test(value))
    return 'Expiry date is not valid';
  const date = moment(value, 'MM / YY');
  if (!date || date.isBefore(moment()))
    return 'Expiry date cannot be set in the past';
  return true;
}
